import { isEqual } from 'lodash'
import { DependencyList, useRef } from 'react'

export const useMemoWithDeepCompare = <T>(factory: () => T, deps: DependencyList): T => {
  const ref = useRef<T>()
  const depsRef = useRef<DependencyList>()

  if (!isEqual(depsRef.current, deps)) {
    depsRef.current = deps
    ref.current = factory()
  }

  return ref.current as T
}
